import React from 'react';
import { useMsal, useAccount } from '@azure/msal-react';
import { msalConfig } from "../../configs/msalConfig";

const UnderMaintenance = () => {
    const { instance } = useMsal();

    const handleLogoutClick = (instance) => {
        const logoutUrl = msalConfig.auth.postLogoutRedirectUri;
        const logoutRequest = {
            account: instance.getActiveAccount(),
            postLogoutRedirectUri: logoutUrl,
        };
        instance.logoutRedirect(logoutRequest);
    }
    return (
        <div style={{ height: '100vh' }}>
            <div className="d-flex align-items-center justify-content-center h-100">
                <div className="text-center text-warning">
                    <h1
                        style={{
                            fontSize: '210px',
                            color: '#ffc107', // Bootstrap warning color
                            fontWeight: 900,
                            textShadow: '4px 4px 0 #fff, 6px 6px 0 #263238',
                        }}
                    >
                        503
                    </h1>
                    <div className="my-3">
                        <h4>WE ARE UNDER MAINTENANCE</h4>
                        <span className="text-muted d-block fs-5">
                            We’re currently performing some scheduled maintenance. <br />
                            Please check back soon.
                        </span>
                    </div>
                    <button to="/" onClick={() => handleLogoutClick(instance)} className="btn btn-primary">
                        Back to Login
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UnderMaintenance;
